/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card class="px-3 py-3">
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardTitle }}</p>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body">Prompt Name</label><br>
                  <input
                    v-model="vmchatbotPromptFormData.prompt_name"
                    type="text"
                    class="form-control"
                    placeholder="Enter prompt name"
                    required
                  />
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationemail_body"> {{cvPromptService}}</label><br>
                  <input
                    v-model="vmchatbotPromptFormData.prompt_service"
                    type="text"
                    class="form-control"
                    placeholder="E.g: API_SERVICE"
                    required
                  />
                </div>
               <div class="col-md-12 mb-3">
                  <label for="validationemail_body">{{cvPromptModuleNameLabel}}</label><br>
                  <select
                    v-model="vmchatbotPromptFormData.prompt_module_name"
                    class="form-control"
                    required
                  >
                    <option :value="null" disabled>Choose Module</option>
                    <option v-for="(module, index) of propModules" :key="(index+1)" :value="module.mod_name">
                      {{module.mod_name}}
                    </option>
                  </select>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body">{{ cvPromptLabel }}</label>
                  <b-form-textarea
                    id="validationemail_body"
                    v-model="vmchatbotPromptFormData.prompt"
                    rows="6"
                    max-rows="12"
                    placeholder="Enter prompt..."
                    required
                  ></b-form-textarea>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationmodule_name">{{cvPromptMacrosLabel}}</label><br>
                  <input
                    v-model="vmchatbotPromptFormData.prompt_macro"
                    type="text"
                    class="form-control"
                    placeholder="Comma-separated macros (e.g. PROMPT_CHATBOT_NAME,PROMPT_QUESTION,PROMPT_ANSWER_CHOICES)"
                    required
                  />
                </div>
                <!-- <div class="col-md-12 mb-3">
                  <label for="validationmodule_object_id">{{cvPromptResponseLabel}}</label>
                  <b-form-textarea
                    id="validationemail_body"
                    v-model="vmchatbotPromptFormData.prompt_response"
                    rows="3"
                    max-rows="12"
                    placeholder="Enter prompt response..."
                    required
                  ></b-form-textarea>
                </div> -->
                <button :disabled="cvLoadingStatus" type="button" class="btn btn-primary mx-2" @click="chatbotPromptAdd()">{{ cvSubmitBtn }}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit"
import { ChatbotPromptApiObj } from "../../../FackApi/api/chatbotPrompt.js"

export default {
  name: "chatbotPromptAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propModules: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      cvCardTitle: "Add Chatbot Prompt",
      cvSubmitBtn: "Add",
      cvPromptService: "Prompt Service",
      cvPromptModuleNameLabel: "Prompt Module Name",
      cvPromptLabel: "Prompt",
      cvPromptMacrosLabel: "Prompt Macros",
      cvPromptResponseLabel: "Prompt Response",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Prompt",
      vmchatbotPromptFormData: Object.assign({}, this.initFormData()),
      vmAdminEmailTempDesc: null,
      vmAdminEmailTempType: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  mounted () {
    socialvue.index()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        prompt_name: "",
        prompt_service: "",
        prompt_module_name: null,
        prompt: "",
        prompt_macro: null
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmchatbotPromptFormData) {
          if (!this.vmchatbotPromptFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }

          if (index === "prompt_macro") {
            const promptMacro = this.vmchatbotPromptFormData[index].trim()
            // Allow only uppercase letters, underscores and commas
            const validFormat = /^[A-Z_]+(,[A-Z_]+)*$/
            if (!validFormat.test(promptMacro)) {
              this.toastMsg = "Prompt Macro must contain only uppercase letters and underscores. Multiple macros must be comma separated."
              this.toastVariant = "danger"
              this.showToast = true
              return false
            }

            // Check for empty values between commas
            if (promptMacro.includes(",") && promptMacro.split(",").some(macro => !macro.trim())) {
              this.toastMsg = "Prompt Macro cannot contain empty values"
              this.toastVariant = "danger"
              this.showToast = true
              return false
            }
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * chatbotPromptAdd
     */
    async chatbotPromptAdd () {
      if (!this.validate()) {
        return false
      }

      try {
        this.cvLoadingStatus = true

        let chatbotPromptAddResp = await ChatbotPromptApiObj.chatbotPromptAdd(this, this.vmchatbotPromptFormData)
        if (chatbotPromptAddResp && !chatbotPromptAddResp.resp_status) {
          this.toastMsg = "Failed to add prompt"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        this.toastMsg = "Prompt added successfully"
        this.toastVariant = "success"
        this.showToast = true

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitClosechatbotPromptAddModal")
        }
        this.vmchatbotPromptFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at chatbotPromptAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
